<template>
  <el-dialog
    :title="$t('text.orderLog')"
    :visible="isShowLogDialog"
    width="1200px"
    @open="freshLog"
    @close="handleDialog"
    :close-on-click-modal="false"
  >
    <div v-if="row">
      <div class="order-number-list">
        <div class="order-number-item">
          <el-tag size="mini">{{ $t("text.collection") }}</el-tag>
          {{ row.orderId }}
        </div>
        <div class="order-number-item">
          <el-tag size="mini" type="success">{{ $t("text.merchant") }}</el-tag>
          {{ row.merchantOrderId }}
        </div>
        <div class="order-number-item">
          <el-tag size="mini" type="warning">{{ $t("text.channel") }}</el-tag>
          <span>{{ row.channelOrderId || "--" }}</span>
        </div>
      </div>
      <table class="order-info-table">
        <tr class="order-info-table-item">
          <th>{{ $t("text.createMessage") }}</th>
          <td>{{ row.createMessage|| '--'  }}</td>
        </tr>
        <tr class="order-info-table-item">
          <th>{{ $t("text.message") }}</th>
          <td>{{ row.msg || '--' }}</td>
        </tr>
        <tr class="order-info-table-item">
          <th>{{ $t("text.queryMessage") }}</th>
          <td>{{ row.queryMessage|| '--'  }}</td>
        </tr>
        <tr class="order-info-table-item">
          <th>{{ $t("text.systemRemark") }}</th>
          <td>{{ row.sysRemark || '--' }}</td>
        </tr>
      </table>
    </div>

    <el-table :data="logList" v-loading="loading">
      <el-table-column
        prop="logTime"
        width="160px"
        :label="$t('text.time')"
      ></el-table-column>
      <el-table-column prop="message" :label="$t('text.log')"></el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleDialog">{{ $t("text.cancel") }}</el-button>
      <el-button type="primary" @click="freshLog">{{
        $t("text.refresh")
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    isShowLogDialog: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
    row: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      logList: [],
      loading: false,
    };
  },
  methods: {
    freshLog() {
      this.loading = true;
      this.$axios
        .get("/order/orderApiLog", {
          params: {
            orderId: this.id,
          },
        })
        .then((res) => {
          if (res.code === 200) {
            this.logList = res.data;
          }
          this.loading = false;
        });
    },
    handleDialog() {
      this.$emit("update:isShowLogDialog", false);
      this.$emit("update:row", null);
    },
  },
};
</script>
<style lang="scss" scoped>
.order-number-list {
  display: flex;
  align-items: center;
  gap: 24px;
  span {
    display: inline-block;
    margin-left: 10px;
  }
}

.order-info-table {
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;
  margin-bottom: 16px;
  border-left: 1px solid #d3dce6;
  border-radius: 4px;
  th,
  td {
    border: 1px solid #d3dce6;
  }
  th {
    border-left: none;
    border-right: none;
  }
  tr {
    width: 50%;
    display: flex;
  }
  th {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 88px;
    background-color: #ebeef5;
    font-weight: bold;
  }
  td {
    flex: 1;
    padding: 12px 16px;
  }
  tr:nth-child(1),
  tr:nth-child(2) {
    td {
      border-bottom: none;
    }
  }

}
</style>
